import { JiraServiceManagementLogo } from '@atlaskit/logo';

import { whyAmISeeingThisRecommendationMessageDefaultReason } from '@post-office/components--ad-controls';

import { JiraYourWorkFirstPartyRecommendation } from '@post-office/components--jira-your-work-first-party-recommendation';

import { FormattedMessage, useIntl } from 'react-intl';

import { createRender } from './types';

import { type JSX } from 'react/jsx-runtime';

import { CCP_PRODUCT_ID, HAMS_PRODUCT_ID, PRODUCT_NAME } from '../../../common/constants';

const whyAmISeeingThisModalContent = {
	message: (
		<p>
			<FormattedMessage
				id="growth.recommendation-jsm.jira-your-work.reasons-modal.message"
				defaultMessage="We think {jsm} will improve your team's productivity. The recommendation is based on:"
				description="Explanation of why we think the JSM recommendation will be relevant to the customer."
				values={{ jsm: <strong>{PRODUCT_NAME}</strong> }}
			/>
		</p>
	),
	reasons: whyAmISeeingThisRecommendationMessageDefaultReason,
};

export type Props = {
	onDismissed: (messageInstanceId: string) => void;
};

export const render: (renderProps: { onDismissed: () => void }) => JSX.Element | null =
	createRender(({ onDismissed }: Props) => {
		const intl = useIntl();

		return (
			<JiraYourWorkFirstPartyRecommendation
				data-testid="jira-your-work-message"
				onDismissed={onDismissed}
				whyAmISeeingThisModalContent={whyAmISeeingThisModalContent}
				app={{
					product: 'Jira Service Management',
					hamsIdentifier: HAMS_PRODUCT_ID,
					ccpProductId: CCP_PRODUCT_ID,
					logo: <JiraServiceManagementLogo size="small" appearance="brand" />,
					header: (
						<FormattedMessage
							id="growth.recommendation-jsm.jira-your-work.header"
							description="Header for Jira Service Management recommendation message in Jira Your Work"
							defaultMessage="Link your teams, make work visible"
						/>
					),
					description: (
						<FormattedMessage
							id="growth.recommendation-jsm.jira-your-work.description"
							description="Description for Jira Service Management recommendation message in Jira Your Work"
							defaultMessage="Connect support teams with development teams to get the full picture, from request to resolution."
						/>
					),
					headerImageAltText: intl.formatMessage({
						id: 'growth.recommendation-jsm.jira-your-work.header-image-alt-text',
						description:
							'Alt text for the header image in Jira Service Management recommendation message in Jira Your Work',
						defaultMessage:
							'Requests from Slack, Teams and email turning into a Jira Service Management request automatically',
					}),
				}}
			/>
		);
	});

export default render;
